import axios from './axios';
import validate from './validate';
import flatpickr from './flatpickr';

export default {
    init() {
        axios.init();
        validate();
        flatpickr();
    },
};
